import { ClientError } from 'graphql-request';

export function extractErrorMessage(error: unknown): {
  message: string;
  code?: string;
} {
  if (error instanceof ClientError) {
    const firstError = error.response.errors?.[0];
    const extensions = firstError?.extensions as
      | { code?: string; userFacingMessage?: string }
      | undefined;
    if (extensions?.userFacingMessage) {
      return { message: extensions.userFacingMessage, code: extensions.code };
    }
    if (firstError?.message) {
      return { message: firstError.message, code: extensions?.code };
    }
  }
  if (error instanceof Error) return { message: error.message };
  return { message: 'Something went wrong' };
}
